import { render } from "./Congrats.vue?vue&type=template&id=6bd47859&scoped=true"
import script from "./Congrats.vue?vue&type=script&lang=js"
export * from "./Congrats.vue?vue&type=script&lang=js"

import "./Congrats.vue?vue&type=style&index=0&id=6bd47859&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd47859"]])

export default __exports__